module.exports = __webpack_public_path__ + "static/ogimg-corporate-leadership-3b12ab3ceaef8edb53668f5f4e870ddf.jpg";